import styled from "styled-components";

export const Wrapper = styled.div`
width: 100%;
height: 100%;
padding-right: 20px;
margin-top: 20px;
`
export const SearchWrapper = styled.div`
margin-left: 20px;
`
export const ButtonsWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
padding-right: 20px;
`
export const Content = styled.div`
div{
    display: flex;
    justify-content: center;
    align-items: center;
}
display: flex;
justify-content: space-between;
align-items: center;
padding-top: 20px;
width: 100%;
`
export const ContentDialogWrapper = styled.div`
width: 100%;
position: relative;
p{
    color: #ffffff !important;
    opacity: 1;
    display: flex;
    justify-content: center;
}
`
export const Filters = styled.div`
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 150%; 
background-color:#f3f6f9;
padding:8px;
border-radius: 5px;
span{
    padding-left: 8px;
    padding-right:8px;
}
&:hover{
    background: rgba(230, 234, 239, 0.30);
    }
`

export const Button = styled.button`
display: flex;
justify-content: center;
align-items: center;
background-color:transparent ;
padding-left: 20px;
padding-right: 20px;
border-radius: 5px;
`
export const Title = styled.span`
color: #2555EF;
font-size: 18px;
font-weight: 600;
margin-left: 24px;
margin-right: 24px;

`
export const StatusWrapper = styled.div`
    width: max-content;
border-radius: 5px;
padding: 5px;
background-color: ${(props)=>(props.status ==='running' ?'rgb(37 85 239 / 20%)':
 props.status ==='scheduled'?"#ffce7eb5" : props.status ==='paused'?"rgb(250 51 114 / 20%)" : props.status ==='active'?"#28c23833": props.status ==='draft'?"#d8d3d3":'' )};
 color: ${(props)=>(props.status ==='running' ?'#2555EF':
 props.status ==='scheduled'?"orange" : props.status ==='paused'?"#FA3372" : props.status ==='active'?"#28c238":
 props.status ==='draft'?"#8E8E8E":'')};
 font-size: 14px;
`
export const AudiencesNames = styled.div`
    width: 20rem;

`